import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

/**
 * New-Campaign wizard open/close. `open(seed)` can pre-fill the wizard (e.g. from the
 * Audience screen); the wizard reads its own real filter options from the API.
 */
const WizardContext = createContext(null);

export function WizardProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [seed, setSeed] = useState(null);

  const open = useCallback((s) => {
    setSeed(s ?? null);
    setIsOpen(true);
  }, []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, seed, open, close }), [isOpen, seed, open, close]);
  return <WizardContext.Provider value={value}>{children}</WizardContext.Provider>;
}

export function useWizard() {
  const ctx = useContext(WizardContext);
  if (!ctx) throw new Error('useWizard must be used within WizardProvider');
  return ctx;
}
